import React, { useEffect, useState } from 'react';
import { adService } from '../api';
import LineChart from './LineChart';
import './StatsModal.css';

const PriceHistoryModal = ({ adId, onClose }) => {
    const [history, setHistory] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        adService.getPriceHistory(adId)
            .then(({ data }) => { if (!cancelled) setHistory(data); })
            .catch(() => { if (!cancelled) setError('Не удалось загрузить историю цены'); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [adId]);

    const series = history ? [{
        key: 'price',
        label: 'Цена',
        color: '#136EF3',
        data: history.map(p => ({ x: new Date(p.changedAt), y: p.price })),
    }] : [];

    return (
        <div className="stats-modal-overlay" onClick={onClose}>
            <div className="stats-modal" onClick={(e) => e.stopPropagation()}>
                <div className="stats-modal__header">
                    <h3>История изменения цены</h3>
                    <button className="stats-modal__close" onClick={onClose}>×</button>
                </div>
                {loading && <div className="stats-modal__loading">Загрузка...</div>}
                {error && <div className="stats-modal__error">{error}</div>}
                {history && history.length === 0 && (
                    <div className="stats-modal__loading">Цена не менялась за последние 30 дней</div>
                )}
                {history && history.length > 0 && (
                    <LineChart
                        series={series}
                        interpolation="step"
                        yFormatter={(v) => `${v.toLocaleString('ru-RU')} ₽`}
                    />
                )}
            </div>
        </div>
    );
};

export default PriceHistoryModal;
